import { render, staticRenderFns } from "./TeacherSelect.vue?vue&type=template&id=65bea560&"
import script from "./TeacherSelect.vue?vue&type=script&lang=js&"
export * from "./TeacherSelect.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports